import React, { FC, useState, FormEvent } from 'react'
import { Confirmation } from '../shared/Confirmation'
import { Dialog } from 'components/Dialog'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import { Stack } from 'components/Stack'
//import { PointCoordinates } from 'models/map'
//import { useGeneratePredictiveReport } from 'services/predictive-report'
import { Icon } from 'components/Icon'
//import { Alert } from 'components/Alert'
//import { Button } from 'components/Button'
//import { PredictiveReportRequest } from 'models/predictive-report'
//import { coordinatesToLngLat } from 'utils/coordinates'
import styles from './MobilityReportWizard.module.scss'
import { useMapEditorContext } from 'context/map-editor-context'
import { useFetchOrganization } from 'services/organization'
import { useUserContext } from 'context/user-context'
//import { UserRoles } from 'models/user'
//import { RadioGroup, RadioButton } from 'components/RadioButton'
import { coordinatesToLngLat } from 'utils/coordinates'
import { useParams } from 'react-router-dom'
import { PointCoordinates } from 'models/map'
import { Flex } from 'components/Flex'
import { Spinner } from 'components/Spinner'
import { StorageProvider } from 'providers/storage'

type Steps = 'confirm' | 'download' | 'loading' | 'ready'

export const PredictiveReportWizard: FC = () => {
  const { t } = useTranslation()

  //var tipoDeReporte = ""
  //const [type, setType] = useState('')
  const { projectId } = useParams()
  const [currentUser] = useUserContext()
  const { organization, status: orgStatus } = useFetchOrganization()
  const [{ confirmed, editor }, mapEditorDispatch] = useMapEditorContext()
  const [step, setStep] = useState<Steps>('confirm')
  const coordinates = editor.feature?.geometry?.coordinates as PointCoordinates
  //const status1 = orgStatus
  //const [generateReport, { data, status }] = useGeneratePredictiveReport()
  //const coordinates = editor.feature?.geometry?.coordinates as PointCoordinates
  //const availableReports = organization?.subscription?.predictiveReports || 0
  //const availableReports = 1000

  var flagFreemium = false
  if (organization?.subscription.level === 'Freemium') {
    flagFreemium = true
  }

  const onDialogClose = () => {
    mapEditorDispatch.cancelWizard()
  }

  //const onSubmit = (event: FormEvent) => {
  //event.preventDefault()
  /*const reportRequestData: PredictiveReportRequest = {
    ...coordinatesToLngLat(coordinates), tipoReporte: tipoDeReporte,
  }
  generateReport(reportRequestData, {
    onSuccess: () => {
      setStep('download')
    },
  })*/
  //setStep('download')
  //}

  const onSubmit = (event: FormEvent) => {
    //React.useEffect(() => { }, [])
    var orgid = organization?.id
    const reportRequestData = {
      ...coordinatesToLngLat(coordinates),
      projectId,
      orgid,
    }
    obtenerData(reportRequestData)
  }

  const obtenerData = async (reportRequestData: any) => {
    setStep('loading')
    var namereporte = valor
    var projectid3 = 'pred'
    var userid = currentUser?.id
    var language = StorageProvider.get('language')

    var url2 =
      'https://report.descifra.global/GetReports.ashx?idorg=' +
      reportRequestData.orgid +
      '&lat=' +
      reportRequestData.lat +
      '&lng=' +
      reportRequestData.lng +
      '&nombre=' +
      namereporte +
      '&Key=RGVzY2lmcmEwOTIz&correo=' +
      String(currentUser!.email) +
      '&type=predictive&mr=' +
      String(organization!.mobilityReport) +
      '&pr=' +
      String(organization!.predictiveReport) +
      '&projectid=' +
      String(projectid3) +
      '&userid=' +
      String(userid) +
      '&language=' +
      language
    const data = await fetch(url2)
    const resp = await data.json()

    if (resp[0].status === '200') {
      setStep('ready')
    } else {
      alert('Error en la generación del reporte, contacta a soporte.')
    }
  }

  var valor = ''
  function handleInputChange(event: any) {
    //const name = event.target.name;
    const value = event.target.value
    valor = value
  }

  const SaveRegFreemium = async () => {
    var url3 =
      'https://report.descifra.global/CallApi.ashx?idorg=' +
      String(organization?.id) +
      '&Key=RGVzY2lmcmEwOTIz&type=predictive&userid=' +
      String(currentUser?.id)
    const data = await fetch(url3)
    const resp = await data.json()

    if (resp[0].status === '200') {
      setStep('ready')
    } else {
      alert('Error en la generación del reporte, contacta a soporte.')
    }
  }

  if (!organization || orgStatus === 'loading') return null
  if (confirmed) {
    return (
      <Dialog
        isOpen={confirmed}
        onClose={onDialogClose}
        aria-label={t(`generate_predictive_report_dialog.${step}.title`)}
        className={styles.mobilityReportDialog}
      >
        <Stack>
          <div>
            <Heading>{t(`generate_predictive_report_dialog.${step}.title`)}</Heading>
            <Text>{t(`generate_predictive_report_dialog.${step}.desc`)}</Text>
          </div>
          {/*(availableReports > 0 ? (
            <Stack space="medium">
              <RadioGroup value={type} onChange={setType}>
                <RadioButton name="isochrone_type" value="time">
                  {t('create_project.isochrone_dialog.timePredictive5')}
                </RadioButton>
                <RadioButton name="isochrone_type" value="time2">
                  {t('create_project.isochrone_dialog.timePredictive10')}
                </RadioButton>
                <div className={styles.radiobutton750}>
                  <RadioButton name="isochrone_type" value="radius">
                    {t('create_project.isochrone_dialog.radiusPredictive750')}
                  </RadioButton>
                </div>
              </RadioGroup>
            </Stack>
          ) : (
              <div className={styles.ocultarValor}>
              </div>
          ))*/}

          {step === 'confirm' &&
            flagFreemium ===
            false /* <ConfirmDownload status={"success"} onSubmit={onSubmit} />*/ && (
              <div>
                <Text>{t(`generate_predictive_report_dialog.${step}.cta`)}</Text>
                <br></br>
                <input
                  className={styles.textInput}
                  id="reportName"
                  type="text"
                  name="nombre"
                  onChange={handleInputChange}
                  placeholder={t(`generate_predictive_report_dialog.${step}.placeholder`)}
                />
                <br></br>
                <br></br>
                <button className={styles.buttonDownload} onClick={onSubmit}>
                  {t(`generate_predictive_report_dialog.${step}.cta`)}
                </button>
              </div>
            )}
          {step === 'confirm' &&
            flagFreemium === true /* <ConfirmDownload status={"success"} onSubmit={onSubmit} />*/ && (
              <div>
                <Text>{t(`generate_predictive_report_dialog.${step}.cta`)}</Text>
                <br></br>
                <input
                  className={styles.textInput}
                  id="reportName"
                  type="text"
                  name="nombre"
                  onChange={handleInputChange}
                  placeholder={t(`generate_predictive_report_dialog.${step}.placeholder`)}
                />
                <br></br>
                <br></br>
                <a
                  //href={data.reportUrl} hikhul
                  href="https://report.descifra.global/PlantillasReportes/DescifraPredictivo_Muestra.pdf"
                  className={styles.downloadLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={SaveRegFreemium}
                >
                  <button className={styles.buttonDownload}>
                    {t(`generate_predictive_report_dialog.${step}.cta`)}
                  </button>{' '}
                </a>
              </div>
            )}

          {step === 'loading' /* <ConfirmDownload status={"success"} onSubmit={onSubmit} />*/ && (
            <div>
              <Text>{t(`mobility_report_dialog.${step}.cta`)}</Text>
              <br></br>
              <Flex justify="center" align="center">
                <Spinner />
              </Flex>
            </div>
          )}
          {step === 'ready' && <Text>{t(`mobility_report_dialog.${step}.cta`)}</Text>}

          <div className={styles.ocultarValor}>{/*tipoDeReporte = type*/}</div>
          {/*step === 'confirm' &&
            (availableReports > 0 ? (
              <ConfirmDownload
                status1={status1}
                availableReports={availableReports}
                onSubmit={onSubmit}
              />
            ) : (
              <NoReportsAvailable />
            )) */}
          {step === 'download' && <DownloadReport data={null} />}
        </Stack>
      </Dialog>
    )
  }
  return <Confirmation onConfirm={() => mapEditorDispatch.setConfirm(true)} />
}
PredictiveReportWizard.displayName = 'PredictiveReportWizard'
const DownloadReport: FC<any> = ({ data }) => {
  //if (!data) return null
  return (
    <a
      //href={data.reportUrl}
      href="https://report.descifra.global/PlantillasReportes/DescifraPredictivo_Muestra.pdf"
      className={styles.downloadLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Text weight="strong" className={styles.fileName} component="span">
        {
          //data.name
          'Reporte Muestra'
        }
      </Text>
      <Icon name="download-line" />
    </a>
  )
}
/*const NoReportsAvailable: FC = () => {
  const { t } = useTranslation()
  const [currentUser] = useUserContext()
  const canPurchase = currentUser?.isRole(UserRoles.OWNER)
  return (
    <Stack space="medium">
      <Alert full tone="critical">
        {t('predictive_report_dialog.confirm.no_reports_left')}
      </Alert>
      {canPurchase ? (
        <div className={styles.ocultarValor}>
        </div>
      ) : (
        <Text>{t('predictive_report_dialog.no_reports.contact_owner')}</Text>
      )}
    </Stack>
  )
}
const ConfirmDownload: FC<any> = ({ availableReports, onSubmit, status1 }) => {
  const { t } = useTranslation()
  return (
    <form onSubmit={onSubmit}>
      <Stack space="medium">
        <Button full type="submit" loading={status1 === 'loading'}>
          {t('predictive_report_dialog.confirm.cta')}
        </Button>
        {status1 === 'error' && (
          <Alert full tone="critical">
            {t('common.messages.error')}
          </Alert>
        )}
      </Stack>
    </form>
  )
} */
